import { render, staticRenderFns } from "./InputDocuments.vue?vue&type=template&id=4648ad62&"
import script from "./InputDocuments.vue?vue&type=script&lang=ts&"
export * from "./InputDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports